var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{attrs:{"placeholder":_vm.setting.placeholder,"hide-details":"auto","dense":"","outlined":""},model:{value:(_vm.setting.value),callback:function ($$v) {_vm.$set(_vm.setting, "value", $$v)},expression:"setting.value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }